const externalToolsEmbed = [
    {
        selector: '[data-external=convert-calculator]',
        path: { filename: 'convertCalculatorEmbed' },
    },
];

export { externalToolsEmbed };
